import PutCompanyRequestModelBase from '../_generated/modelBases/put-company-request-model-base';

export default class PutCompanyRequestModel extends PutCompanyRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
